import { useAtom } from "jotai";
import { useState } from "react";
import { toast } from "react-toastify";
import dataService from "../../../../../../helpers/dataService";
import { billingAddressesAtom } from "../../../atoms/atoms";
import { changeSelectedAddress } from "../../../subscriptionContext/subscriptionReducer";
import { useSubscriptionStore } from "../../../subscriptionContext/SubscriptionStore";

const useBillingAddresses = (onFinish) => {
  const [subState, dispatch] = useSubscriptionStore();
  const [billingAddresses, setBillingAddresses] = useAtom(billingAddressesAtom);
  const [errors, setErrors] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const saveBillingAddress = (selectedAddress, noDispatch = false) => {
    setIsSaving(true);
    dataService.patch(
      `subscriptions/${subState.id}/billing-address`,
      {
        billingAddress: selectedAddress,
      },
      (data) => {
        if (!noDispatch) {
          dispatch(
            changeSelectedAddress(billingAddresses.find((b) => b.id == selectedAddress))
          );
        }
        toast.success("Adresse de facturation modifiée");
        onFinish();
      },
      (err) => {},
      () => {
        setIsSaving(false);
      }
    );
  };

  const modifyBillingAddress = (newAddress) => {
    //ajouter l'envoi de la nouvelle adresse à l'api
    setIsSaving(true);
    dataService.patch(
      `customer-addresses/${newAddress.id}`,
      newAddress,
      (datas) => {
        saveBillingAddress(newAddress.id, true);
        setBillingAddresses((addresses) =>
          addresses.map((b) => (b.id == datas.id ? datas : b))
        );
        dispatch(changeSelectedAddress(datas));

        onFinish();
      },
      setErrors,
      () => setIsSaving(false)
    );
  };

  const createBillingAddress = (newAddress) => {
    //ajouter l'envoi de la nouvelle adresse à l'api
    setIsSaving(true);
    dataService.post(
      `customer-addresses`,
      newAddress,
      (datas) => {
        //rattachement à l'abonnement en premier, avant toute mise à jour de l'affichage
        saveBillingAddress(datas.id, true);
        setBillingAddresses((addresses) => [...addresses, datas]);
        dispatch(changeSelectedAddress(datas));
        toast.success("Nouvelle adresse créée");

        onFinish();
      },
      setErrors,
      () => setIsSaving(false)
    );
  };

  const deleteBillingAddress = (addressId) => {
    if (window.confirm("Confirmez-vous la suppression de cette adresse ?")) {
      setIsDeleting(addressId);
      dataService.remove(
        `customer-addresses/${addressId}`,
        {},
        (datas) => {
          setBillingAddresses((addresses) => addresses.filter((b) => b.id != addressId));
          setIsDeleting(false);
          toast.success("Adresse supprimée avec succès");
        },
        (err) => setIsDeleting(false)
      );
    }
  };

  return {
    subState,
    billingAddresses,
    isDeleting,
    saveBillingAddress,
    modifyBillingAddress,
    createBillingAddress,
    deleteBillingAddress,
    isSaving,
    errors,
  };
};

export default useBillingAddresses;
